module.exports = __webpack_public_path__ + "img/login_2.55d3ff32.png";